import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

import {
  FiUsers, FiClock, FiUserCheck, FiCheckCircle, FiCalendar, FiBarChart2,FiGrid ,
  FiPhoneCall
} from 'react-icons/fi';
import StatCard from './DashboardComponents/StatCard';
import AIVoiceCard from './DashboardComponents/AIVoiceCard';
import CallAnalytics from './DashboardComponents/CallAnalytics';
import ActiveModulesCard from './DashboardComponents/ActiveModulesCard';
import { getVendorProfile } from '../../redux/services/authService/authApi';
import { openModal } from "../../redux/features/modalSlice";
import { successToast,errorToast } from '../../Utils/toast';
import {
  getDashboardCounts,
  getTodayDashboardCounts,
  getPieChartData,
  getActiveModules,
} from '../../redux/services/dashboardServices/dashboard.Services'; 
import { venderKyc } from '../../Utils/role';
const ICONS = {
  leads: <FiUsers />,
  pending: <FiClock />,
  assigned: <FiUserCheck />,
  converted: <FiCheckCircle />,
  calls: <FiPhoneCall />,
};
function Dashboard() {
  const navigate = useNavigate();
  const [mode, setMode]                     = useState('total');
  const [totalData, setTotalData]           = useState({});
  const [todayData, setTodayData]           = useState({});
  const [pieData, setPieData]               = useState([]);
  const [modules, setModules]               = useState([]);
  const [loading, setLoading]               = useState(true);
  const [modulesLoading, setModulesLoading] = useState(true);
   const [showKycPopup, setShowKycPopup]     = useState(false); 
   const [kycStatus, setKycStatus] = useState(null);
  const { permissions } = useSelector((state) => state.auth);
  //    useEffect(() => {
  //   const kycStatus = venderKyc();
  //   if (kycStatus && kycStatus.toLowerCase() === 'pending') {
  //     setShowKycPopup(true);
  //   }
  // }, []);

useEffect(() => {
  const checkKyc = async () => {
    try {
      const res = await getVendorProfile();
      const status = res?.data?.data?.kyc_status;
          setKycStatus(status?.toLowerCase());
      if (status && status.toLowerCase() === 'pending') {
        setShowKycPopup(true);
      }
       
    } catch (err) {
      console.error('KYC check failed:', err);
    }
  };
  checkKyc();
}, []);

  useEffect(() => {
    loadAll();
    loadModules();
  }, []);
  const loadAll = async () => {
    try {
      setLoading(true);
      const [totalRes, todayRes, pieRes] = await Promise.allSettled([
        getDashboardCounts(),
      getTodayDashboardCounts(),
      getPieChartData(),
      ]);
      if (totalRes.status === 'fulfilled') setTotalData(totalRes.value?.data || {});
      if (todayRes.status === 'fulfilled') setTodayData(todayRes.value?.data || {});
      if (pieRes.status === 'fulfilled') {
        const raw = pieRes.value?.data || [];
        setPieData(Array.isArray(raw) ? raw : []);
      }
    } catch (err) {
      console.error(err);
      errorToast('Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  };

  const loadModules = async () => {
    try {
      setModulesLoading(true);
      const res = await getActiveModules();
      const list = res?.data?.modules || [];
      setModules(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error(err);
      errorToast('Failed to load modules');
    } finally {
      setModulesLoading(false);
    }
  };
const handleKycOk = () => {
    setShowKycPopup(false);
    navigate('/add-kyc');
  };

  const handleKycCancel = () => {
    setShowKycPopup(false);
  };
  const isTotal = mode === 'total';
  const stats = isTotal
    ? [
        { title: 'Total Leads',     icon: ICONS.leads,     value: (totalData.total_leads ?? 0).toLocaleString(),     change: `${todayData.today_total_leads ?? 0} today`,     subtitle: 'All time',        onClick: () => navigate('/leads/other') },
        { title: 'Pending Leads',   icon: ICONS.pending,   value: (totalData.pending_leads ?? 0).toLocaleString(),   change: `${todayData.today_pending_leads ?? 0} today`,   subtitle: 'Awaiting action', onClick: () => navigate('/leads/pending') },
        { title: 'Converted Leads', icon: ICONS.converted, value: (totalData.converted_leads ?? 0).toLocaleString(), change: `${todayData.today_converted_leads ?? 0} today`, subtitle: 'Success',         onClick: () => navigate('/leads/other') },
        { title: 'AI Calls',        icon: ICONS.calls,     value: '—',                                               change: 'Live calls',                                     subtitle: 'Real-time',       onClick: () => navigate('/leads/call-outcomes') },
      ]
    : [
        { title: "Today's Leads",     icon: ICONS.leads,     value: (todayData.today_total_leads ?? 0).toLocaleString(),     change: `${todayData.today_unassigned_lead ?? 0} unassigned`, subtitle: 'Added today', onClick: () => navigate('/leads') },
        { title: "Today's Pending",   icon: ICONS.pending,   value: (todayData.today_pending_leads ?? 0).toLocaleString(),   change: 'Pending action',                                     subtitle: 'Today',       onClick: () => navigate('/leads/pending') },
        { title: "Today's Converted", icon: ICONS.converted, value: (todayData.today_converted_leads ?? 0).toLocaleString(), change: 'Success',                                            subtitle: 'Today',       onClick: () => navigate('/leads/other') },
        { title: "Today's Calls",     icon: ICONS.calls,     value: '—',                                                     change: 'Live calls',                                         subtitle: 'Real-time',   onClick: () => navigate('/leads/call-outcomes') },
      ];
  return (
    <>
    <div className="main_page">

{kycStatus && kycStatus !== "approved" && (
  <div
    className="kyc-marquee-wrapper"
    onClick={() => navigate("/add-kyc")}
    style={{ cursor: "pointer" }}
  >
    <div className="kyc-marquee">
    
        <span className="kyc-warning">⚠️
        <strong>KYC Approval Pending:</strong>{" "}
        Your KYC is currently pending approval.
        Please complete your KYC form to proceed.
        &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </div>
  </div>
)}

      <div className="dt-header dashboard-header">
        <div className="dt-header-left">
          <div className="dt-header-icon"><FiBarChart2 /></div>
          <div>
            <h1>Dashboard Overview</h1>
            <p>Track your lead activity at a glance.</p>
          </div>
        </div>

        {/* <div className="dash-mode-toggle">
          <button type="button" className={`dash-mode-btn ${mode === 'total' ? 'active' : ''}`} onClick={() => setMode('total')}>
            <FiUsers /> Total
          </button>
          <button type="button" className={`dash-mode-btn ${mode === 'today' ? 'active' : ''}`} onClick={() => setMode('today')}>
            <FiCalendar /> Today
          </button>
        </div> */}
      </div>
      {/* <div className="grid">
        {stats.map((s) => (
          <StatCard key={s.title} {...s} loading={loading} />
        ))}
      </div> */}

      {/* <div className="main-grid">
        <AIVoiceCard />
        <CallAnalytics data={pieData} loading={loading} />
      </div> */}
   <ActiveModulesCard
      modules={modules}
      loading={modulesLoading}
      subscribedMenuIds={permissions?.allowedMenus || []}
    />
    </div>
    </>
  );
}

export default Dashboard;